import { useState } from 'react';
import { PaymentBlockProps } from './PaymentBlock';
import { MINIMUM_PAYMENT_AMOUNT } from '../../config';
import { useLang } from '../hooks/useLanguage';

function CashPaymentBlock({
    amount,
    maxAmount,
    onCancel,
    paymentMethod,
    onStartTransaction,
}: PaymentBlockProps) {
    const [note, setNote] = useState<string>('');
    const { getI18n, t } = useLang();

    return (
        <div className="fireknife-payment-methods">
            <h2 className="fireknife-payment-methods__title">
                {getI18n(paymentMethod.name, paymentMethod.nameI18n)}{' '}
                {t('paymentmethods.paymentBlock')}
            </h2>

            <div className="payment-methods__form-group">
                <div className="fireknife-form-control-box">
                    <label className="fireknife-form-label">
                        {t('widgetReservationInfo.paymentMethods.note')}
                    </label>
                    <div className="fireknife-form-control-box">
                        <input
                            className="fireknife-form-control"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="fireknife-payment-methods__btn-box">
                {onCancel && (
                    <button
                        className="fireknife-payment-methods__btn fireknife-payment-methods__btn--cancel fireknife-btn fireknife-btn--secondary"
                        onClick={onCancel}
                        type="button"
                    >
                        {t('common.cancel')}
                    </button>
                )}

                <button
                    className="fireknife-payment-methods__btn fireknife-payment-methods__btn--pay fireknife-btn fireknife-btn--primary"
                    onClick={() => {
                        onStartTransaction({
                            note,
                        });
                    }}
                    type="button"
                    // cannot do a split if less than 1 usd is one of the parts (either the one paid or the remaining portion)
                    disabled={
                        amount && maxAmount
                            ? (amount < MINIMUM_PAYMENT_AMOUNT && amount !== maxAmount) ||
                              (maxAmount - amount < MINIMUM_PAYMENT_AMOUNT && amount !== maxAmount)
                            : false
                    }
                >
                    {t('widgetReservationInfo.payButton')}
                </button>
            </div>
        </div>
    );
}

export default CashPaymentBlock;
